export const getReportStatus = (report) => {
  const disabledStatuses = ['pending', 'failed', 'big_report_error'];

  return {
    pending: report.state === 'pending',
    failed: report.state === 'failed',
    bigReportError: report.state === 'big_report_error',
    disabled: disabledStatuses.includes(report.state),
  };
};

export const redirectToCustomReports = (path = '') => {
  const redirectURL = new URL(`/custom_exports${path}`, window.location.origin);
  window.location.assign(redirectURL.href);
};
